import { useSegments } from 'expo-router'

export const NOT_FOUND_SEGMENT = '+not-found'

export const useIsNotFoundRoute = () => {
  const segments = useSegments()

  return segments.includes(NOT_FOUND_SEGMENT)
}
